// randomLogo.js
var randomLogo = pc.createScript('randomLogo');

randomLogo.attributes.add('materialAsset', {
    type: 'asset',
    assetType: 'material'
});

randomLogo.attributes.add('numFrames', {
    type: 'number',
    default: 1,
    description: 'Number of frames to play before looping'
});

randomLogo.attributes.add('startFrame', {
    type: 'number',
    default: 0,
    description: 'Frame to start animation from'
});

randomLogo.attributes.add('delayFrame', {
    type: 'number',
    default: -1,
    description: 'Frame to stop the animation'
});

randomLogo.attributes.add('delayDuration', {
    type: 'number',
    default: 1,
    description: 'duration for the delay'
});

randomLogo.attributes.add('width', {
    type: 'number',
    default: 1,
    description: 'Number of frames wide'
});

randomLogo.attributes.add('height', {
    type: 'number',
    default: 1,
    description: 'Number of frames high'
});

randomLogo.attributes.add('frameRate', {
    type: 'number',
    default: 1,
    description: 'Playback frames per second'
});


randomLogo.prototype.delayFrameBuffer = 0;
randomLogo.prototype.delayTick = 0;
randomLogo.prototype.isDelaying = false;
randomLogo.prototype.allowOneCycle = false;

// initialize code called once per entity
randomLogo.prototype.initialize = function() {
    
    this.startFrame = Math.floor(Math.random() * 9);
    console.log('startFrame: ' + this.startFrame);
    if (this.materialAsset) {
        this.material = this.materialAsset.resource;
    }
    
    this.timer = 1/this.frameRate;
    this.frame = this.startFrame;
    this.transform = new pc.Vec4();

    this.updateMaterial(this.frame);
    
    
    this.delayFrameBuffer = this.delayDuration * this.frameRate;
    //console.log(this.delayFrameBuffer, this.delayDuration, this.frameRate);
};

// update code called every frame
randomLogo.prototype.update = function(dt) {
    
    //prevents update if numframes are static
    if(this.numFrames <= 1) { return;}
    
    // calculate when to animate to next frame
    this.timer -= dt;
    
    if (this.timer < 0) {
        if(this.isDelaying) {
            this.delayTick += 1;
            
            //console.log(this.delayTick, this.delayFrameBuffer);
            
            if(this.delayTick >= this.delayFrameBuffer) {
                this.delayTick = 0;
                this.isDelaying = false;
            }
            
            this.frame = this.delayFrame;
        } else {
            // move to next frame
            this.frame++;
        }
        
        
        if (this.frame >= (this.numFrames + this.startFrame)) {
            this.frame = this.startFrame;
        }

        this.updateMaterial(this.frame);
        
        //checking if a delay frame is set and setting flag on first match
        if(this.delayFrame >= 0) {
            if(this.delayFrame == this.frame && !this.isDelaying){
                if(this.allowOneCycle) {
                    this.isDelaying = true;    
                }
                this.allowOneCycle = !this.allowOneCycle;
            }    
        }
        
        // reset the timer
        this.timer = 1/this.frameRate;
    }
};



randomLogo.prototype.updateMaterial = function (frame) {
    // calculate how much to change UV to go to next frame
 
    var dx = 1 / this.width;
    var dy = 1 / this.height;

    // Convert frame number into UV co-ordinate
    var x = frame % this.width;
    var y = Math.floor(frame / this.width);

    var meshes = this.entity.model.meshInstances;

    // create the transform vector (tilingx, tilingy, offsetx, offsety)
    // and override the material properties for this mesh
    // This allows us to use different settings for different Entities, but share the same material
    this.transform.set(dx, dy, x * dx, (1 - dy) - (y * dy));
    console.info(meshes);
    var data = [this.transform.x, this.transform.y, this.transform.z, this.transform.w];
    
    if(meshes !== null) {
        for (var i = 0; i < meshes.length; i++) {
            console.log('data: ' + data);
            meshes[i].setParameter("texture_diffuseMapTransform", data);
            meshes[i].setParameter("texture_emissiveMapTransform", data);
            meshes[i].setParameter("texture_opacityMapTransform", data);
        }
    }
    
};


